import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { HeroBackground, PageHeader } from '../components';

interface LinkItem {
  name: string;
  url: string;
  description: string;
}

interface LinkCategory {
  title: string;
  links: LinkItem[];
}

export const LinksPage: React.FC = () => {
  const { t } = useTranslation();

  const linkCategories = t('links.categories', {
    returnObjects: true,
  }) as LinkCategory[];

  return (
    <div>
      {/* Hero header cropped to 1/3 */}
      <HeroBackground size='third' />

      {/* Page Title */}
      <PageHeader title={t('nav.links')} subtitle={t('subtitles.links')} />

      <div className='max-w-4xl mx-auto px-5 py-4'>
        {/* Liens utiles */}
        <div>
          {linkCategories.map((category, index) => (
            <div key={index} className='mb-4 bg-church-light rounded-lg p-5'>
              <h3 className='text-church-brown text-lg font-medium mb-4'>
                {category.title}
              </h3>
              <div className='space-y-3'>
                {category.links.map((link, linkIndex) => (
                  <div
                    key={linkIndex}
                    className='border-l-4 border-church-gold pl-4'
                  >
                    <a
                      href={link.url}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='text-church-brown hover:text-church-dark font-medium inline-flex items-center gap-1'
                    >
                      {link.name} <ExternalLink className='w-3.5 h-3.5' />
                    </a>
                    <p className='text-sm text-gray-600 mt-1'>
                      {link.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Section contact */}
        <div className='mt-6 bg-church-light rounded-lg p-5 text-center'>
          <h3 className='text-church-brown font-medium text-xl mb-3'>
            {t('links.propose_title')}
          </h3>
          <p className='text-gray-600 mb-4'>
            {t('links.propose_text')}
          </p>
          <Link
            to='/contact'
            className='inline-block bg-church-brown text-white px-6 py-3 rounded-md hover:bg-church-dark transition-colors font-medium'
          >
            {t('links.contact_button')}
          </Link>
        </div>
      </div>
    </div>
  );
};
